import { createFormHook, createFormHookContexts } from '@tanstack/react-form'
import { TextField } from '@/components/form/text-field'
import { SubmitButton } from '@/components/form/submit-button'
import { ChooseBlinds } from '@/components/form/choose-blinds'
import { SwitchButtons } from '@/components/SwitchButtons'

export const { fieldContext, formContext, useFieldContext, useFormContext } =
  createFormHookContexts()

export const { useAppForm, withForm } = createFormHook({
  fieldComponents: {
    TextField,
    ChooseBlinds,
    SwitchButtons,
  },
  formComponents: {
    SubmitButton,
  },
  fieldContext,
  formContext,
})
